module.exports = __webpack_public_path__ + "img/5425003947261.a63ae740.png";